import type { IdentifyExperienceFormValues, RhfCriteriaValue } from './IdentifyExperienceStep.schema';
import { ExperienceCriteria } from '@/Models/ExperienceCriteria';

export const mapRhfCriteriaToExperienceCriteria = (rhfCriteria: RhfCriteriaValue): ExperienceCriteria => ({
    id: rhfCriteria.criteriaId,
    criterion: rhfCriteria.value,
});

export const mapExperienceCriteriaToRhfCriteria = (criteria: ExperienceCriteria): RhfCriteriaValue => ({
    criteriaId: criteria.id,
    value: criteria.criterion,
});

export function buildDefaultValuesFromContext(experienceCriteria: ExperienceCriteria[]): IdentifyExperienceFormValues {
    return {
        criteria: experienceCriteria.map(mapExperienceCriteriaToRhfCriteria),
    };
}
